import * as THREE from 'three';
import { solidworksDefaultPreset } from '../imported-model/render/solidworks-default-preset';

/** 装配体编辑态非目标零部件透明度。 */
const ASSEMBLY_COMPONENT_EDIT_TRANSPARENT_OPACITY = 0.28;

/**
 * 装配体编辑零部件材质工厂。
 *
 * 设计说明：
 * 1. 编辑零部件态属于装配体视口外观语义，材质创建统一收口到 material 层；
 * 2. 灰色来源复用 SolidWorks 默认材质预设，避免装配体编辑态与其它模型外观漂移；
 * 3. 该工厂只创建材质实例，不持有缓存，具体替换、恢复与释放由装配体编辑控制器负责。
 */
export class AssemblyComponentEditMaterialFactory {
  /**
   * 创建灰色不透明材质。
   *
   * @returns 灰色不透明实体材质。
   */
  public static createOpaqueGrayMaterial(): THREE.MeshStandardMaterial {
    return new THREE.MeshStandardMaterial({
      color: solidworksDefaultPreset.material.plasticColor,
      metalness: solidworksDefaultPreset.material.baseMetalness,
      roughness: solidworksDefaultPreset.material.baseRoughness,
      transparent: false,
      opacity: solidworksDefaultPreset.material.defaultOpacity,
      depthTest: true,
      depthWrite: true,
      side: THREE.DoubleSide,
    });
  }

  /**
   * 创建灰色半透明材质。
   *
   * @returns 灰色半透明实体材质。
   */
  public static createTransparentGrayMaterial(): THREE.MeshStandardMaterial {
    return new THREE.MeshStandardMaterial({
      color: solidworksDefaultPreset.material.plasticColor,
      metalness: solidworksDefaultPreset.material.baseMetalness,
      roughness: solidworksDefaultPreset.material.baseRoughness,
      transparent: true,
      opacity: ASSEMBLY_COMPONENT_EDIT_TRANSPARENT_OPACITY,
      depthTest: true,
      depthWrite: false,
      side: THREE.DoubleSide,
    });
  }
}
